import React from 'react';
import {
    Flex, HStack, Box, Button, IconButton, Tooltip, Text, Portal, useDisclosure,
    Popover, PopoverTrigger, PopoverContent, PopoverBody,
    Modal, ModalOverlay, ModalContent, ModalBody, ModalCloseButton
} from '@chakra-ui/react';
import { FaSmile, FaPlus } from 'react-icons/fa';
import EmojiPicker from 'emoji-picker-react';

const QUICK_EMOJIS = ['👍', '❤️', '😂', '😮', '😢', '🙏'];

const CommentReactions = ({ reactions = [], onToggle }) => {
    const fullPicker = useDisclosure();

    return (
        <Flex mt={3} gap={2} flexWrap="wrap" align="center">
            {reactions.map((rx) => (
                <Tooltip key={rx.emoji} label={(rx.users || []).join(', ')} hasArrow>
                    <Button
                        size="xs"
                        variant={rx.reacted ? 'solid' : 'outline'}
                        colorScheme={rx.reacted ? 'blue' : 'gray'}
                        borderRadius="full"
                        onClick={() => onToggle(rx.emoji)}
                    >
                        <Text as="span" mr={1}>{rx.emoji}</Text>{rx.count}
                    </Button>
                </Tooltip>
            ))}

            <Popover isLazy placement="bottom-start" gutter={6}>
                {({ onClose }) => (
                    <>
                        <PopoverTrigger>
                            <IconButton
                                size="xs"
                                variant="ghost"
                                colorScheme="gray"
                                borderRadius="full"
                                aria-label="Adicionar reacao"
                                icon={<FaSmile />}
                            />
                        </PopoverTrigger>
                        <Portal>
                            <PopoverContent w="auto" maxW="92vw">
                                <PopoverBody p={2}>
                                    <HStack spacing={1}>
                                        {QUICK_EMOJIS.map((emoji) => (
                                            <Button
                                                key={emoji}
                                                variant="ghost"
                                                size="sm"
                                                fontSize="xl"
                                                px={2}
                                                onClick={() => { onToggle(emoji); onClose(); }}
                                            >
                                                {emoji}
                                            </Button>
                                        ))}
                                        <Tooltip label="Mais emojis" hasArrow>
                                            <IconButton
                                                aria-label="Mais emojis"
                                                icon={<FaPlus />}
                                                size="sm"
                                                variant="outline"
                                                borderRadius="full"
                                                onClick={() => { onClose(); fullPicker.onOpen(); }}
                                            />
                                        </Tooltip>
                                    </HStack>
                                </PopoverBody>
                            </PopoverContent>
                        </Portal>
                    </>
                )}
            </Popover>

            <Modal isOpen={fullPicker.isOpen} onClose={fullPicker.onClose} isCentered size="xs">
                <ModalOverlay />
                <ModalContent w="auto" maxW="92vw" bg="transparent" boxShadow="none">
                    <ModalCloseButton zIndex={2} bg="white" borderRadius="full" />
                    <ModalBody p={0}>
                        <Box w={{ base: '300px', sm: '340px' }} maxW="92vw" mx="auto">
                            <EmojiPicker
                                onEmojiClick={(emojiData) => { onToggle(emojiData.emoji); fullPicker.onClose(); }}
                                lazyLoadEmojis
                                width="100%"
                                height={420}
                                previewConfig={{ showPreview: false }}
                                skinTonesDisabled
                            />
                        </Box>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </Flex>
    );
};

export default CommentReactions;
